export { parseTime } from '@/utils/ruoyi'
import dayjs from 'dayjs'

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
  const si = [
    { value: 1E18, symbol: 'E' },
    { value: 1E15, symbol: 'P' },
    { value: 1E12, symbol: 'T' },
    { value: 1E9, symbol: 'G' },
    { value: 1E6, symbol: 'M' },
    { value: 1E3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

/**
 * 10000 => "10,000.00"
 * @param {number} num
 */
export function toThousandFilterfixed2(num) {
  var str = isNaN(num) || undefined ? 0.00 : parseFloat(num).toFixed(2)
  str = (str || 0.00).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
  if (str === 'NaN') {
    str = '0.00'
  }
  return str
}

/**
 * 10000 => "10000.00"
 * @param {number} num
 * @param {com} 金额符号
 */
export function tofixed2(num,com='') {
  var str = isNaN(num) ? 0.00 : parseFloat(num).toFixed(2)
  if (str === 'NaN'||str === '0.00') {
    str = '免费'
  }
  return str==='免费'?str:com+str
}

/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

/**
 * 给值添加单位
 * @param {String} string
 */
export function addUnit(value, unit) {
  return value + unit
}

export function filterEnum(value, list) {
  const result = list.find(item => item.value === value)
  return result ? result.label : ''
}

export function filterDate(value, format = 'YYYY-MM-DD HH:mm:ss') {
  if (value === '0001-01-01 00:00:00' || !value) {
    return '-'
  }
  try {
    return dayjs(value).format(format)
  } catch (e) {
    return ''
  }
}

export function filterEmpty(value, symbol = '-') {
  return value === undefined || value === null ? symbol : value
}

// type: h 小时、m 分钟、 s 秒
// places: 精确到小数点后几位
export function millisecondToOther(value, type = 'h', places = 1) {
  if (!value) {
    return value
  }
  const divisorList = {
    h: 1000 * 60 * 60,
    m: 1000 * 60,
    s: 1000
  }
  const unitList = {
    h: '小时',
    m: '分',
    s: '秒'
  }
  return (value / divisorList[type]).toFixed(places) + unitList[type]
}

export function stohms(ss) {
  if (!ss) {
    return ''
  }
  let h = parseInt(ss/60/60%24);
	let m = parseInt(ss/60%60)
	let s = parseInt(ss%60)
	return h+'小时'+m+'分钟'
}

export function numFilter(value){
  let realVal = parseFloat(value).toFixed(2)
  return "￥" + realVal
}
export function keepDecimals(price) {
  if(typeof price !== 'number') return
  return price.toFixed(2)
}
// 截取部分字符串长度展示
export function ellipsis(value, num) {
  if (!value) return ''
  if (value.length > num) {
    return value.slice(0, num) + '...'
  }
  return value
}
// 将阿拉伯数字转换为汉字的算法
export function transformation (num) {
  const changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'] // changeNum[0] = "零"
  const unit = ['', '十', '百', '千', '万']
  num = parseInt(num)
  const getWan = (temp) => {
    const strArr = temp.toString().split('').reverse()
    let newNum = ''
    for (var i = 0; i < strArr.length; i++) {
      newNum = (i === 0 && strArr[i] === 0 ? '' : (i > 0 && strArr[i] === 0 && strArr[i - 1] === 0 ? '' : changeNum[strArr[i]] + (strArr[i] === 0 ? unit[0] : unit[i]))) + newNum
    }
    return newNum
  }
  const overWan = Math.floor(num / 10000)
  let noWan = num % 10000;
  if (noWan.toString().length < 4) noWan = '0' + noWan
  return overWan ? ('第'+getWan(overWan) + '万' + getWan(noWan)+'版') : ('第'+getWan(num)+'版' )
}
